import { useEffect } from 'react';
import { ANALYTICS_EVENT } from '@/common/constants/analyticsEvents';
import { useAnalytics } from '@/common/contexts/AnalyticsContext';
import ProfileDetailsModal from './components/profileDetailsModal/ProfileDetailsModal';
import HomeBannerCarousel from './components/homeBannerCarousel/HomeBannerCarousel';
import StoriesBar from './components/storiesBar/StoriesBar';
import CategoryScroll from './components/categoryScroll/CategoryScroll';
import HomeLoungeMood from './components/homeLoungeMood/HomeLoungeMood';
import HomePersonGrid from './components/homePersonGrid/HomePersonGrid';
import { useHomePersons } from './hooks/useHomePersons';
import { HomeView } from './home.styles';

const Home = () => {
	const { trackAnalytics } = useAnalytics();
	const {
		storyPersons,
		filteredPersons,
		tags,
		isTagsLoading,
		selectedProfile,
		setSelectedProfile,
		activeCategory,
		setActiveCategory,
		handleReloadImage,
		handleCloseProfile,
		loadNextPage,
		handleSurprise,
		hasMore,
		isStoriesLoading,
		isLoadingMore,
	} = useHomePersons();

	useEffect(() => {
		trackAnalytics(ANALYTICS_EVENT.HOME.OPEN);
	}, []);

	const handleSelectProfile = (profile) => {
		trackAnalytics(ANALYTICS_EVENT.HOME.PROFILE_OPEN, {
			personId: profile?._id ?? null,
		});
		setSelectedProfile(profile);
	};

	return (
		<>
			{selectedProfile && (
				<ProfileDetailsModal
					profile={selectedProfile}
					onClose={handleCloseProfile}
					chatStartEvent={ANALYTICS_EVENT.HOME.CHAT_START}
					analyticsSource="home"
				/>
			)}
			<HomeView id="homeView" data-view="home">
				<HomeBannerCarousel />
				<StoriesBar persons={storyPersons} isLoading={isStoriesLoading} />
				<HomeLoungeMood onSurprise={handleSurprise} />
				<CategoryScroll
					tags={tags}
					isLoading={isTagsLoading}
					activeCategory={activeCategory}
					onCategoryChange={setActiveCategory}
				/>
				<HomePersonGrid
					persons={filteredPersons}
					onSelectProfile={handleSelectProfile}
					onReload={handleReloadImage}
					hasMore={hasMore}
					onLoadMore={loadNextPage}
					isLoadingMore={isLoadingMore}
					isLoading={isStoriesLoading}
				/>
			</HomeView>
		</>
	);
};

export default Home;
